import { gql } from "apollo-boost";
import { useQuery } from "@apollo/react-hooks";
import { idtype, image } from "querypieces";

const footer = gql`
  query {
    footer: globalSet(handle: "footer") {
      ... on footer_GlobalSet {
        footerBuilder {
          ...on copy_Entry {
            ${idtype}
            block
          }
          ...on address_Entry {
            ${idtype}
            block
          }
          ...on socialLink_Entry {
            ${idtype}
            icon {
              id
              url
              width
              height
              alt
            }
            linkUrl
          }
        }
        copyright: richTextSimple
        embed
      }
    }
  }
`;

export default () => {
  return useQuery(footer);
};
